import * as React from 'react'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { IOption, IProviderProps } from '@user/components/Filters'
import { useGetSourcesOnMount } from '@user/store/sources/hooks/useGetSourcesOnMount'
import { selectAllSources } from '@user/store/sources/slice'

export const LeadSourceProvider: FC<IProviderProps> = ({ render }) => {
  const status = useGetSourcesOnMount()
  const sources = useSelector(selectAllSources)

  const data = useMemo(
    () => sources.map<IOption>((s) => ({ label: s.name, value: s.id })),
    [sources],
  )

  return <>{render(data, status === 'pending')}</>
}
LeadSourceProvider.displayName = 'LeadSourceProvider'
